import { render, staticRenderFns } from "./stats-expand.vue?vue&type=template&id=3d0b8dad&scoped=true&"
import script from "./stats-expand.vue?vue&type=script&lang=js&"
export * from "./stats-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b8dad",
  null
  
)

export default component.exports